module.exports = {
	"title": "CSS Regions",
	"description": "Method of flowing content into multiple elements.",
	"spec": "http://www.w3.org/TR/css3-regions/",
	"status": "wd",
	"links": [
		{
			"url": "http://html.adobe.com/webstandards/cssregions/",
			"title": "Adobe demos and samples"
		},
		{
			"url": "http://msdn.microsoft.com/en-us/ie/hh272902#_CSSConnected",
			"title": "IE10 developer guide info"
		},
		{
			"url": "http://docs.webplatform.org/wiki/css/atrules/@region",
			"title": "WebPlatform Docs"
		},
		{
			"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=674802",
			"title": "Firefox feature request bug"
		}
	],
	"bugs": [],
	"categories": [
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "a x #1",
			"11": "a x #1",
			"5.5": "n"
		},
		"edge": {
			"12": "a x #1",
			"13": "a x #1",
			"14": "a x #1"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "a x",
			"16": "a x",
			"17": "a x",
			"18": "a x",
			"19": "n d",
			"20": "n d",
			"21": "n d",
			"22": "n d",
			"23": "n d",
			"24": "n d",
			"25": "n d",
			"26": "n d",
			"27": "n d",
			"28": "n d",
			"29": "n d",
			"30": "n d",
			"31": "n d",
			"32": "n d",
			"33": "n d",
			"34": "n d",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"54": "n",
			"55": "n",
			"56": "n",
			"57": "n"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "y x",
			"7.1": "y x",
			"9.1": "y x",
			"TP": "y x"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "y x",
			"10": "y x",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "y x",
			"8.1-8.4": "y x",
			"9.0-9.2": "y x",
			"9.3": "y x"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "n",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "n",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "n"
		},
		"and_ff": {
			"49": "n"
		},
		"ie_mob": {
			"10": "a x #1",
			"11": "a x #1"
		},
		"and_uc": {
			"11": "y x"
		},
		"samsung": {
			"4": "n"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "Support is limited to using an iframe as a content source with the `-ms-flow-into: flow_name;` and `-ms-flow-from: flow_name;` syntax."
	},
	"usage_perc_y": 20.55,
	"usage_perc_a": 6.21,
	"ucprefix": false,
	"parent": "",
	"keywords": "",
	"ie_id": "regions",
	"chrome_id": "5655612935372800",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-regions.json
 ** module id = 429
 ** module chunks = 0
 **/